// @flow strict

import React from 'react';
import { GatsbyImage, getImage, GatsbyImageProps } from 'gatsby-plugin-image';
import { useLanguageContext } from '~contexts/language-context';
import * as styles from './glossary-intro.module.less';

type GlossaryIntroProps = {
  headline: string,
  text: string,
  introImage: GatsbyImageProps,
};

export const GlossaryIntro = ({
  headline,
  text,
  introImage,
}: GlossaryIntroProps) => {
  const image = getImage(introImage);
  const { loc } = useLanguageContext();

  return (
    <div className={styles.pageIntro}>
      <div className={styles.pageIntro__imageContainer}>
        <GatsbyImage image={image} alt={loc('_glossary_intro_image_alt')} />
      </div>
      <div className={styles.pageIntro__textContainer}>
        <h1 className={styles.pageIntro__headline}>{headline}</h1>
        <p className={styles.pageIntro__text}>{text}</p>
      </div>
    </div>
  );
};
